import { Box, Button } from '@mui/material';

const BrandHeader = ({ compact = false }) => (
    <Box
        component="header"
        sx={{
            width: '100%',
            maxWidth: 1200,
            mx: 'auto',
            px: { xs: 2.5, md: 4 },
            py: compact ? 2.25 : { xs: 2.5, md: 3.5 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: compact ? 'flex-end' : 'space-between',
            boxSizing: 'border-box',
        }}
    >
        {!compact ? (
            <Button
                component="a"
                href="#survey-setup"
                variant="text"
                sx={{ color: 'text.primary', fontWeight: 700, display: { xs: 'none', sm: 'inline-flex' } }}
            >
                Set up a survey
            </Button>
        ) : null}
    </Box>
);

export default BrandHeader;
